/* eslint-env browser */
import _ from 'lodash';

import { combineReducers } from 'redux';
import { setterReducer } from 'frontend/state/utils';

import types from 'frontend/state/actionTypes';
import { isBetaHost } from 'shared/util';

const customBuildReducer = (state = null) => state;

const overlayReducer = setterReducer({
  set: types.SHOW_OVERLAY,
  reset: types.CLEAR_OVERLAY,
  initial: '',
});

const talentTreeOverlayReducer = setterReducer({
  set: types.SET_TALENT_TREE_OVERLAY,
  reset: [types.CLEAR_TALENT_TREE_OVERLAY, types.CHANGE_ROUTE],
  initial: null,
});

const statusFieldReducer = (field, defaultValue, transform) => (state = defaultValue, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.FETCH_STATUS_SUCCESS: {
      if (!payload || !payload.site) {
        return state;
      }
      let value = payload.site[field];
      if (transform) {
        value = transform(value);
      }
      return value || defaultValue;
    }
    default:
      return state;
  }
};

export default combineReducers({
  customBuild: customBuildReducer,
  overlay: overlayReducer,
  talentTreeOverlay: talentTreeOverlayReducer,
  slowMode: statusFieldReducer('slowMode', false, sm => !!parseInt(sm)),
  alertMessage: statusFieldReducer('alertMessage', ''),
  alertLinkText: statusFieldReducer('alertLinkText', ''),
  alertLinkUrl: statusFieldReducer('alertLinkUrl', ''),
  alertTheme: statusFieldReducer('alertTheme', ''),
});

export const selectors = {
  customBuild: state => state.site.customBuild,
  overlay: state => state.site.overlay,
  talentTreeOverlay: state => state.site.talentTreeOverlay,
  slowMode: state => state.site.slowMode,
  isBetaSite: state => {
    return isBetaHost(_.get(window, 'location.href')) || Boolean(state.site.customBuild);
  },
  alertMessage: state => state.site.alertMessage,
  alertLinkText: state => state.site.alertLinkText,
  alertLinkUrl: state => state.site.alertLinkUrl,
  alertTheme: state => state.site.alertTheme,
};
